import styled from 'styled-components';

export const SubscriptionTabStyle = styled.div`
  position: relative;
  font-size: 15px;
  line-height: 1.55;
  color: var(--ink);

  .info-block {
    width: 100%;
    padding: 18px 20px;
    border-radius: var(--r-lg);
    border: 1px solid var(--line);
    background: var(--white);
    box-shadow: var(--shadow-soft);
  }

  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 12px;
    flex-wrap: wrap;
  }

  .title {
    display: block;
    font-size: 16px;
    line-height: 1.3;
    font-weight: 600;
    margin: 0;
    color: var(--ink);
  }

  .list-holder {
    width: 100%;
    padding-top: 4px;
    margin-top: 4px;
    border-top: 1px solid var(--line);

    .subtitle {
      display: block;
      font-weight: 600;
      color: var(--ink);
      margin: 16px 0 12px;
    }

    .list {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
        color: var(--mute);

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
`;
